/**
 *
 * @returns {any} - Returns the parsed state from localStorage or undefined if not found.
 * @description This function loads the state from localStorage. It tries to parse the JSON string and returns the object. If parsing fails or the item is not found, it returns undefined.
 */
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('kanziState');
    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
};

/**
 *
 * @param state {any} - The state to be saved to localStorage. It should be a serializable object.
 * @returns {void}
 * @description This function saves the state to localStorage. It stringifies the state and stores it under the key 'kanziState'.
 */
export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('kanziState', serializedState);
  } catch (error) {
    console.error('Error saving state to localStorage', error);
  }
};

/**
 *
 * @param key {string} - The key to store the data under. Default is 'kanziTour'.
 * @param data {object} - The data to be stored. It should contain 'tourCompleted' and 'kanziVersion'.
 * @returns {void}
 * @description This function saves the Kanzi tour data to localStorage. It stringifies the data and stores it under the specified key.
 */
export const saveKanziTour = (
  key = 'kanziTour',
  data: {
    tourCompleted: boolean;
    kanziVersion: string;
  }
) => {
  try {
    const kanziTourData = JSON.stringify(data);
    localStorage.setItem(key, kanziTourData);
  } catch (error) {
    console.error('Error saving Kanzi tour data to localStorage', error);
  }
};

/**
 *
 * @param key {string} - The key under which the data is stored. Default is 'kanziTour'.
 * @returns {object | undefined} - Returns the parsed data if it exists, otherwise returns undefined.
 * @description This function loads the Kanzi tour data from localStorage. It parses the JSON string and returns the object.
 */
export const loadKanziTour = (
  key = 'kanziTour'
):
  | {
      tourCompleted: boolean;
      kanziVersion: string;
    }
  | undefined => {
  try {
    const kanziTourData = localStorage.getItem(key);
    // Check if the data is null or empty
    if (kanziTourData === null) {
      return undefined;
    }

    return JSON.parse(kanziTourData);
  } catch (error) {
    return undefined;
  }
};
